import React from "react";
import { ListTableColumn, createListTableColumns, Stack, ListTable, renderName, renderDate } from "sprint-common-web";

import { renderContent } from "../../../../common/components/listings/renderContent";
import { renderOrderProgress } from "../../../../common/components/listings/renderOrderProgress";
import { renderOrderResolutions } from "../../../../common/components/listings/renderOrderResolutions";
import { renderSoundtracksAvailabilityList } from "../../../../common/components/listings/renderSoundtracksAvailability";
import { renderSubtitlesAvailabilityList } from "../../../../common/components/listings/renderSubtitlesAvailabilityList";
import { renderTargetFilenames } from "../../../../common/components/listings/renderTargetFilenames";
import { renderVideoAvailability } from "../../../../common/components/listings/renderVideoAvailability";
import { ProjectedOrderItem } from "./BuzzOrderProjectedOrderItem";

interface BuzzOrderProjectedOrdersProps {
    projectedCloudOrders: ProjectedOrderItem[];
}

export const BuzzOrderProjectedOrders: React.FC<BuzzOrderProjectedOrdersProps> = ({
    projectedCloudOrders
}: BuzzOrderProjectedOrdersProps) => {
    const columns: ListTableColumn<ProjectedOrderItem>[] = createListTableColumns<
        ProjectedOrderItem & { resolution: string }
    >([
        {
            type: "basic",
            key: "pONumber",
            name: "PO Number",
            minWidth: 100,
            maxWidth: 180
        },
        {
            type: "basic",
            key: "content",
            name: "Content",
            minWidth: 100,
            maxWidth: 300,
            isResizable: true,
            isSortable: true,
            onRender: renderContent
        },
        {
            type: "basic",
            key: "airline",
            name: "Airline",
            minWidth: 100,
            maxWidth: 180,
            isResizable: true,
            isSortable: true,
            onRender: renderName
        },
        {
            type: "basic",
            key: "system",
            name: "System",
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            isSortable: true,
            onRender: renderName
        },
        {
            type: "basic",
            key: "startDate",
            name: "Start Date",
            minWidth: 90,
            maxWidth: 90,
            isResizable: true,
            isSortable: true,
            onRender: renderDate
        },
        {
            type: "basic",
            key: "dueDate",
            name: "Due Date",
            minWidth: 90,
            maxWidth: 90,
            isResizable: true,
            isSortable: true,
            onRender: renderDate
        },
        {
            type: "basic",
            key: "progress",
            name: "Progress",
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            isSortable: true,
            onRender: renderOrderProgress
        },
        {
            type: "basic",
            key: "targetFilenames",
            name: "Target filenames",
            minWidth: 120,
            maxWidth: 200,
            isResizable: true,
            onRender: renderTargetFilenames
        },
        {
            type: "basic",
            key: "resolution",
            name: "Resolution",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) =>
                renderOrderResolutions({
                    targetResolution: item?.video.targetResolution,
                    sourceResolution: item?.video.sourceResolution
                })
        },
        {
            type: "basic",
            key: "video",
            name: "Video",
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            onRender: renderVideoAvailability
        },
        {
            type: "basic",
            key: "soundtracks",
            name: "Soundtracks",
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            onRender: renderSoundtracksAvailabilityList
        },
        {
            type: "basic",
            key: "subtitles",
            name: "Subtitles",
            minWidth: 250,
            maxWidth: 250,
            isResizable: true,
            onRender: renderSubtitlesAvailabilityList
        },
        {
            type: "basic",
            key: "deliveryFolder",
            name: "Delivery folder",
            minWidth: 50,
            maxWidth: 110
        }
    ]);

    return (
        <Stack>
            <ListTable columns={columns} items={projectedCloudOrders} isLoading={false} layoutMode="fixedColumns" />
        </Stack>
    );
};
